export const HOURS_MINUTES_REGEX = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
export const PHONE_REGEX = /^\+?\d{1,3}?[- ]?\(?(?:\d{2,3})\)?[- ]?\d\d\d[- ]?\d\d\d\d$/;
export const NUMBER_REGEX = /^\d*$/;